/* eslint-disable no-unused-expressions */

import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import sysJwt from "../../../utils/sysJwt";
import SysForm from "../../commonComponents/sysForm";
import { post } from "../../../utils/sysAxios";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { confirmAlert } from "react-confirm-alert";
import SysTable from "../../commonComponents/SysTable";

class Offers extends Component {
  state = {
    data: {
      ArName: "",
      EnName: "",
      KuName: "",
      ArDescription: "",
      EnDescription: "",
      KuDescription: "",
      CompoundId: "",
      UnitTypeId: "",
      Area: "",
      PropertySize: "",
      Bedrooms: "",
      Bathrooms: "",
      Price: "",
      DiscountPercentage: "",
      SellerName: "",
      SellerPhone: "",
      Purpose: "",
      Latitude: "",
      Longitude: "",
      offerAmenities: [],
      offerServices: [],
      files: "",
      currency: "",
    },

    contentHeader: "Offers",
    addButtonLabel: "Add Offer",
    addButtonIcon: "fa fa-plus",

    dataUrl: "/api/data/GetOffers",
    singleItemUrl: "/api/data/GetOffer",
    addUrl: "/api/data/AddOffer",
    editUrl: "/api/data/EditOffer",
    deleteUrl: "/api/data/DeleteOffer",

    inEditMode: false,
    inModalMode: false,
    modalHeaderAdd: "Add Offer",
    modalSubmitButtonLabelAdd: "Add",
    modalSubmitButtonIconAdd: "fa fa-plus",
    modalHeaderEdit: "Edit Offer",
    modalSubmitButtonLabelEdit: "Edit",
    modalSubmitButtonIconEdit: "fa fa-edit",
    modalWidth: "50vw",

    editEntityId: 0,
    amenitiesDropdown: [],
    servicesDropdown: [],
    compoundsDropdown: [],
    unitTypesDropdown: [],
    unitTypesDropdownDisable: true,
    purposesDropdown: [
      { label: "For Sale", value: 1 },
      { label: "For Rent", value: 2 },
    ],
    currencyDropdown: [
      { label: "USD", value: "USD" },
      { label: "IQD", value: "IQD" },
    ],

    tableData: [],
  };

  componentDidMount() {
    this.getData();
    this.getAmentiesDropdown();
    this.getOfferServicesDropdown();
    this.getCompoundsDropdown();
  }

  getAmentiesDropdown() {
    post("/api/data/getallamenities", null, this.props.updateIsLoading).then(
      (apiResponse) => {
        this.setState({
          amenitiesDropdown: apiResponse.data.respData.data,
        });
      }
    );
  }

  getOfferServicesDropdown() {
    post(
      "/api/data/getallofferservices",
      null,
      this.props.updateIsLoading
    ).then((apiResponse) => {
      this.setState({
        servicesDropdown: apiResponse.data.respData.data,
      });
    });
  }

  getCompoundsDropdown() {
    post(
      "/api/data/GetAllCompoundsDropdown",
      null,
      this.props.updateIsLoading
    ).then((apiResponse) => {
      this.setState({
        compoundsDropdown: apiResponse.data.respData.data,
      });
    });
  }

  getUnitTypesDropdown(compoundId) {
    if (compoundId) {
      post(
        "/api/data/GetUnitTypesDropdown",
        { CompoundId: compoundId },
        this.props.updateIsLoading
      ).then((apiResponse) => {
        this.setState({
          unitTypesDropdown: apiResponse.data.respData.data,
        });
      });
    } else {
      this.setState({
        unitTypesDropdown: [],
      });
    }
  }

  onChangeCompoundsDropdown = (inputValue) => {
    this.getUnitTypesDropdown(inputValue);
    this.setState({ unitTypesDropdownDisable: false });
  };

  updateForm = (inputId, inputValue) => {
    var data = this.state.data;
    data[inputId] = inputValue;
    this.setState({ data });
  };

  showForm() {
    this.setState({ inModalMode: true });
  }

  closeModal() {
    var data = this.state.data;

    Object.keys(data).forEach(function (key) {
      Array.isArray(data[key]) ? (data[key] = []) : (data[key] = "");
    });

    this.setState({
      inModalMode: false,
      inEditMode: false,
      data: data,
      editEntityId: 0,
    });

    this.getData();
  }

  getData() {
    post(this.state.dataUrl, null, this.props.updateIsLoading).then(
      (apiResponse) => {
        this.setState({ tableData: apiResponse.data.respData.data });
      }
    );
  }

  getEditFormData(row) {
    return post(
      this.state.singleItemUrl,
      { id: row.ID },
      this.props.updateIsLoading
    ).then((apiResponse) => {
      var data = this.state.data;

      data["ArName"] = apiResponse.data.respData.data[0].AR_NAME;
      data["EnName"] = apiResponse.data.respData.data[0].EN_NAME;
      data["KuName"] = apiResponse.data.respData.data[0].KU_NAME;
      data["ArDescription"] = apiResponse.data.respData.data[0].AR_DESCRIPTION;
      data["EnDescription"] = apiResponse.data.respData.data[0].EN_DESCRIPTION;
      data["KuDescription"] = apiResponse.data.respData.data[0].KU_DESCRIPTION;
      data["CompoundId"] = apiResponse.data.respData.data[0].COMPOUND_ID;
      data["UnitTypeId"] = apiResponse.data.respData.data[0].UNIT_TYPE_ID;
      data["Area"] = apiResponse.data.respData.data[0].AREA;
      data["PropertySize"] = apiResponse.data.respData.data[0].PROPERTY_SIZE;
      data["Bedrooms"] = apiResponse.data.respData.data[0].BEDROOMS;
      data["Bathrooms"] = apiResponse.data.respData.data[0].BATHROOMS;
      data["Price"] = apiResponse.data.respData.data[0].PRICE;
      data["DiscountPercentage"] =
        apiResponse.data.respData.data[0].DISCOUNT_PERCENTAGE;
      data["SellerName"] = apiResponse.data.respData.data[0].SELLER_NAME;
      data["SellerPhone"] = apiResponse.data.respData.data[0].SELLER_PHONE;
      data["Purpose"] = apiResponse.data.respData.data[0].PURPOSE;
      data["Latitude"] = apiResponse.data.respData.data[0].LATITUDE;
      data["Longitude"] = apiResponse.data.respData.data[0].LONGITUDE;
      data["currency"] = apiResponse.data.respData.data[0].CURRENCY;

      for (
        var i = 0;
        i < apiResponse.data.respData.data[0].AMENITIES.length;
        i++
      ) {
        data["offerAmenities"].push(
          apiResponse.data.respData.data[0].AMENITIES[i].AMENITY_ID
        );
      }

      for (
        var i = 0;
        i < apiResponse.data.respData.data[0].SERVICES.length;
        i++
      ) {
        data["offerServices"].push(
          apiResponse.data.respData.data[0].SERVICES[i].SERVICE_ID
        );
      }

      this.getUnitTypesDropdown(apiResponse.data.respData.data[0].COMPOUND_ID);
      this.setState({
        unitTypesDropdownDisable: false,
        data: data,
        editEntityId: apiResponse.data.respData.data[0].ID,
      });
    });
  }

  handleDelete(row) {
    confirmAlert({
      title: this.props.t("dialog.deleteTitle"),
      message: this.props.t("dialog.deleteConfirm"),
      buttons: [
        { label: this.props.t("btn.yes"),
          onClick: () => {
            post(
              this.state.deleteUrl,
              { id: row.ID },
              this.props.updateIsLoading
            ).then((apiResponse) => {
              apiResponse.data.respCode === 0 ? this.getData() : null;
            });
          },
        },
        { label: this.props.t("btn.cancel"),
          onClick: () => null,
        },
      ],
    });
  }

  doSubmit() {
    const submitData = Object.assign({}, this.state.data);

    if (this.state.inEditMode) {
      submitData["id"] = this.state.editEntityId;
    }

    const data = new FormData();
    if (this.state.data.files) {
      Array.from(this.state.data.files).map((member) =>
        data.append("files", member, member.name)
      );
    }

    data.append("requestData", JSON.stringify(submitData));

    post(
      this.state.inEditMode ? this.state.editUrl : this.state.addUrl,
      data,
      this.props.updateIsLoading
    ).then((apiResponse) => {
      if (apiResponse.data.respCode === 0) {
        this.props.updateIsLoading(false);
        this.closeModal();
      }
    });
  }

  getColumns() {
    const { t } = this.props;
    return [
      {
        id: 1,
        label: t("col.arabicName"),
        field: "AR_NAME",
      },
      {
        id: 2,
        label: t("col.englishName"),
        field: "EN_NAME",
      },
      {
        id: 3,
        label: t("col.kurdishName"),
        field: "KU_NAME",
      },
      {
        id: 4,
        label: t("col.arabicDescription"),
        field: "AR_DESCRIPTION",
      },
      {
        id: 5,
        label: t("col.englishDescription"),
        field: "EN_DESCRIPTION",
      },
      {
        id: 6,
        label: t("col.kurdishDescription"),
        field: "KU_DESCRIPTION",
      },
      {
        id: 7,
        label: t("col.purpose"),
        field: "PURPOSE",
      },
      {
        id: 8,
        label: t("col.compound"),
        field: "COMPOUND",
      },
      {
        id: 9,
        label: t("col.unitType"),
        field: "UNIT_TYPE",
      },
      {
        id: 10,
        label: t("col.category"),
        field: "CATEGORY",
      },
      {
        id: 11,
        label: t("col.area"),
        field: "AREA",
      },
      {
        id: 12,
        label: t("col.propertySize"),
        field: "PROPERTY_SIZE",
      },
      {
        id: 13,
        label: t("col.bedrooms"),
        field: "BEDROOMS",
      },
      {
        id: 14,
        label: t("col.bathrooms"),
        field: "BATHROOMS",
      },
      {
        id: 15,
        label: t("col.price"),
        field: "PRICE",
      },
      {
        id: 16,
        label: t("col.discountPercentage"),
        field: "DISCOUNT_PERCENTAGE",
      },
      {
        id: 17,
        label: t("col.currency"),
        field: "CURRENCY",
      },
      {
        id: 18,
        label: t("col.insertDate"),
        field: "INSERT_DATE",
      },
      {
        id: 19,
        label: t("col.lastUpdate"),
        field: "LAST_UPDATE",
      },
      {
        id: 20,
        label: t("col.actions"),
        field: "SYS_ACTINOS",
        width: "100px",
        maxResizeWidth: "100px",
        resizable: false,
        pinned: true,
        cellRenderer: ({ data }) => {
          return (
            <div id="outer">
              {sysJwt.isAuthorized(["CB5E"]) && (
                <div className="inner" title="Edit">
                  <button
                    className="dropdown-item btn-popup-menu"
                    disabled={this.props.isLoading}
                    onClick={() => {
                      this.getEditFormData(data).then(() => {
                        this.setState({
                          inEditMode: true,
                        });
                        this.showForm();
                      });
                    }}
                  >
                    <i className="fa fa-edit" />
                  </button>
                </div>
              )}
              {sysJwt.isAuthorized(["CB5F"]) && (
                <div className="inner" title="Delete">
                  <button
                    className="dropdown-item btn-popup-menu"
                    disabled={this.props.isLoading}
                    onClick={() => this.handleDelete(data)}
                  >
                    <i className="fa fa-trash" />
                  </button>
                </div>
              )}
            </div>
          );
        },
      },
    ];
  }

  render() {
    const { t } = this.props;
    return (
      <div className="bms-content-component fade-in">
        <div className="row">
          <div className="col">
            <h4>{t("pages.offers")}</h4>
          </div>
          <div className="col flex-container-left">
            {sysJwt.isAuthorized(["CB5D"]) && (
              <Button
                label={t("pages.addOffer")}
                icon={this.state.addButtonIcon}
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => {
                  this.setState({ inEditMode: false });
                  this.showForm();
                }}
              />
            )}
          </div>
        </div>
        <hr />
        <Dialog
          visible={this.state.inModalMode}
          style={{ width: this.state.modalWidth }}
          onHide={(e) => this.closeModal()}
          dismissableMask={true}
          closable={false}
          header={
            <h5 className="modal-header">
              {this.state.inEditMode ? t("dialog.editTitle") : t("dialog.addTitle")}
            </h5>
          }
          footer={
            <div>
              <Button
                label={this.state.inEditMode ? t("btn.edit") : t("btn.add")}
                icon={
                  this.state.inEditMode
                    ? this.state.modalSubmitButtonIconEdit
                    : this.state.modalSubmitButtonIconAdd
                }
                className="p-button-rounded p-button-secondary"
                disabled={this.props.isLoading}
                onClick={() => this.doSubmit()}
              />
              <Button
                label={t("btn.cancel")}
                icon="fa fa-close"
                className="p-button-rounded p-button-danger"
                onClick={() => this.closeModal()}
              />
            </div>
          }
        >
          <SysForm
            isLoading={this.props.isLoading}
            inEditMode={this.state.inEditMode}
            data={this.state.data}
            updateForm={this.updateForm}
            inputs={[
              {
                type: "text",
                id: "ArName",
                label: t("col.arabicName"),
                disabled: false,
              },
              {
                type: "text",
                id: "EnName",
                label: t("col.englishName"),
                disabled: false,
              },
              {
                type: "text",
                id: "KuName",
                label: t("col.kurdishName"),
                disabled: false,
              },
              {
                type: "text",
                id: "ArDescription",
                label: t("col.arabicDescription"),
                disabled: false,
              },
              {
                type: "text",
                id: "EnDescription",
                label: t("col.englishDescription"),
                disabled: false,
              },
              {
                type: "text",
                id: "KuDescription",
                label: t("col.kurdishDescription"),
                disabled: false,
              },
              {
                type: "dropdown",
                id: "CompoundId",
                label: t("col.compound"),
                options: this.state.compoundsDropdown,
                disabled: false,
                customOnChangeHandler: this.onChangeCompoundsDropdown,
              },
              {
                type: "dropdown",
                id: "UnitTypeId",
                label: t("col.unitType"),
                options: this.state.unitTypesDropdown,
                disabled: this.state.unitTypesDropdownDisable,
              },
              {
                type: "dropdown",
                id: "Purpose",
                label: t("col.purpose"),
                options: this.state.purposesDropdown,
                disabled: false,
              },
              {
                type: "text",
                id: "Area",
                label: t("col.area"),
                disabled: false,
              },
              {
                type: "text",
                id: "PropertySize",
                label: t("col.propertySize"),
                disabled: false,
              },
              {
                type: "text",
                id: "Bedrooms",
                label: t("col.bedrooms"),
                disabled: false,
              },
              {
                type: "text",
                id: "Bathrooms",
                label: t("col.bathrooms"),
                disabled: false,
              },
              {
                type: "text",
                id: "Price",
                label: t("col.price"),
                disabled: false,
              },
              {
                type: "text",
                id: "DiscountPercentage",
                label: t("col.discountPercentage"),
                disabled: false,
              },
              {
                type: "dropdown",
                id: "currency",
                label: t("col.currency"),
                options: this.state.currencyDropdown,
                disabled: false,
              },
              {
                type: "text",
                id: "SellerName",
                label: t("col.sellerName"),
                disabled: false,
              },
              {
                type: "text",
                id: "SellerPhone",
                label: t("col.sellerPhone"),
                disabled: false,
              },
              {
                type: "multiselect",
                id: "offerAmenities",
                label: t("col.offerAmenities"),
                options: this.state.amenitiesDropdown,
                disabled: false,
              },
              {
                type: "multiselect",
                id: "offerServices",
                label: t("col.offerServices"),
                options: this.state.servicesDropdown,
                disabled: false,
              },
              {
                type: "text",
                id: "Latitude",
                label: t("col.latitude"),
                disabled: false,
              },
              {
                type: "text",
                id: "Longitude",
                label: t("col.longitude"),
                disabled: false,
              },
              {
                type: "multiplefileupload",
                id: "files",
                label: t("col.attachments"),
                disabled: false,
              },
            ]}
          />
        </Dialog>
        <SysTable
          columns={this.getColumns()}
          rows={this.state.tableData}
          pageSizes={[10, 15, 20, 25, 30]}
        />
      </div>
    );
  }
}

export default withTranslation()(Offers);
